import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};


Vue.use(Router);

const router = new Router({
    mode: 'hash',
    // FIXED: ME
    scrollBehavior: function(to){
        if (to.hash) {
            return {
                selector: to.hash
            }
        } else {
            return {x: 0, y: 0}
        }
    },
    routes,
});

export default router;